<div
    [ngClass]="{
        'driving': dataType === TACHO_TYPE_DATA.Driving,
        'work': dataType === TACHO_TYPE_DATA.Work,
        'rest': dataType === TACHO_TYPE_DATA.Rest,
        'availability': dataType === TACHO_TYPE_DATA.Availability
    }"
    class="container-vehicle"
>
    <div class="container-vehicle__left">
        <img [ngClass]="{'active-driving': slotData.CurrentState === 0 }" class="driving" src="/assets/img/tacho/active@3x.png" alt="">
        <img [ngClass]="{'active-work': slotData.CurrentState === 1 }" class="work" src="/assets/img/tacho/primary_3@3x.png" alt="">
        <img [ngClass]="{'active-rest': slotData.CurrentState === 2 }"  class="rest" src="/assets/img/tacho/primary_4@3x.png" alt="">
        <img class="availability" src="/assets/img/tacho/primary_6@3x.png" alt="">
    </div>
    <div class="container-vehicle__right">
        <div class="container-vehicle__right__item section-header">
            <span class="title">
                <ng-container *ngIf="dataType === TACHO_TYPE_DATA.Driving">
                    {{'drive'|translate}}
                </ng-container>
                <ng-container *ngIf="dataType === TACHO_TYPE_DATA.Work">
                    {{'work'|translate}}
                </ng-container>
                <ng-container *ngIf="dataType === TACHO_TYPE_DATA.Rest">
                    {{'vehicle-details-tacho-tab.rest'|translate}}
                </ng-container>
                <ng-container *ngIf="dataType === TACHO_TYPE_DATA.Availability">
                    {{'available'|translate}}
                </ng-container>
            </span>
            <span class="value">
                {{'duration'|translate}}
            </span>
        </div>

        <div *ngFor="let item of data" class="container-vehicle__right__item">
            <span [innerHTML]="item.title" class="title"></span>
            <span class="value">
                {{item.value}}
            </span>
        </div>
    </div>
</div>
